// Parsed from the client-supplied "underground422 whith elec.dxf" (Intergeo).
// Coordinates are MTM Zone 8, in metres: [easting, northing, elevation].
//
// The DXF stores several LWPOLYLINE entities in object coordinate systems.
// These points have been transformed to world survey coordinates. A handful
// of endpoints transformed to an impossible elevation of 0; their elevation
// was estimated from the local route elevation trend. The standalone BT arc
// at elevation 0 was omitted because its vertical placement is indeterminate.
export const TERREBONNE_ELECTRICAL_NETWORK_INTERGEO = {
  CablesBT: [
    [
      [293681.760979, 5064494.180743, 56.199823],
      [293710.454044, 5064544.977253, 55.959384],
      [293738.580656, 5064594.767407, 55.508887],
      [293766.44098, 5064644.090743, 55.339823],
      [293784.751087, 5064675.595831, 55.23],
      [293786.056779, 5064677.907492, 55.22],
    ],
    [
      [293831.5, 5064661.4, 55.169998],
      [293885.32, 5064650.86, 54.900002],
    ],
    [
      [293796.01, 5064680.29, 55.220002],
      [293792.650552, 5064680.685099, 55.22],
    ],
    [
      [293772.19, 5064595.43, 55.41],
      [293809.72, 5064588.009999, 55.189999],
      [293839.897246, 5064582.273916, 55.01],
    ],
  ],
  CablesHTA: [
    [
      [293885.475403, 5064617.70706, 55.290059],
      [293783.913648, 5064637.378265, 55.310001],
    ],
    [
      [293783.402361, 5064637.471986, 55.310127],
      [293778.519999, 5064638.549996, 55.310127],
      [293737.929833, 5064661.002475, 55.779621],
      [293737.779999, 5064661.049995, 55.780124],
    ],
  ],
} as const;
